import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'search.page.filter.title',
    defaultMessage: `Filtres`,
  },
  superSherpaBody: {
    id: 'search.page.filter.title.super.sherpas.body',
    defaultMessage:
      'Les Sherpas est un endroit sûr : nous vérifions l’identité et les diplômes de nos professeurs et les formons afin de vous assurer des cours de qualité.',
  },
  link: {
    id: 'search.page.filter.title.super.sherpas.link',
    defaultMessage: 'En savoir plus',
  },
});
